import styled from "styled-components";

import { DrawerBoxWrapper } from "../../common/Drawer/DrawerBoxWrapper";
import { ExpandablePanelWrapper } from "../../common/Panel/ExpandablePanelWrapper";
import { PanelHeaderWrapper } from "../../common/Panel/PanelHeaderWrapper";

const SettingsDrawerBoxWrapper = styled(DrawerBoxWrapper)`
  padding: 0;

  ${PanelHeaderWrapper} {
    padding: 1.2rem 1rem;
  }

  ${ExpandablePanelWrapper} {
    margin-top: 0;
    padding: 0rem 1rem;
    padding-bottom: ${props =>
      props.children.props.expanded ? "1.2rem" : "0rem"};
  }
`;

export { SettingsDrawerBoxWrapper };
